/**
 *  Date    : 2021/08/28
 *  Author  : lbb1811
 *  Declare : AuthWrap
 *  Description: 通过hasPhoneNumber, showLoginModal, canCancelLogin三个参数控制login弹窗
 */

import React, { useEffect } from 'react';

import { officialAccountsId } from '@/config';
import { useActions, useSelector } from '@/utils/redux';
import LoginModal from './LoginModal';

export default function AuthWrap() {

  const { hasPhoneNumber, showLoginModal, canCancelLogin } = useSelector(state => state.reader);
  const { updateLoginState, getUserPhoneNumber } = useActions(({ reader }) => reader);

  useEffect(() => {
    getUserPhoneNumber({ officialAccountsId });
  }, []);

  const onCloseLogin = (logined) => {
    if(logined) {
      updateLoginState({
        showLoginModal: false,
        routeSpm: '0'
      });
      getUserPhoneNumber();
    } else {
      canCancelLogin &&
      updateLoginState({
        showLoginModal: false,
        routeSpm: '0'
      }); // 关闭弹窗
    }
  };

  if(hasPhoneNumber || !showLoginModal) {
    return null;
  } else {
    return <LoginModal onClose={onCloseLogin} />;
  }
}
